import BlogDetailsContainer from "../../../components/miscellaneous/blog/blogDetails";

const BlogDetails = () => {
  return <BlogDetailsContainer />;
};

export default BlogDetails;
